import React, { useState, useEffect, useContext } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import MeetingFormSchedule from 'components/brandActivation/meetingFormSchedule/meetingFormSchedule';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import Regex from 'services/utils/regex/Regex';
import parse from 'html-react-parser';
import ErrModalPop from 'components/sales/modal/errorModal';
import { Link } from 'react-router-dom';
import {toast} from "react-toastify";
import {handleValidateObj} from 'constants/objValues/objvalues';
import {validateObject} from 'constants/objValues/validateObject';
import useLatLng from 'hooks/uselatlng/uselatlng';


const SchedulePlanMeeting = ({
  pocList,
  getPocList,
  createMeeting,
  updateMeeting,
  match,
  history,
  meetingById = null,
  getMeetingById,
  getCorpClientList,
  corpClientList,
  getCorpPocList,
  documentUploadUrl,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  corpClientPoc,
  getInvoiceList,
  invoiceList,
  getBaOpportunityFromLeadx,
  opportunityList=[]
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [teamId, setTeamId] = useState();
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const [viewMeeting, setViewMeeting] = useState({});
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [meetingId,setMeetingId] = useState(null);
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [mapLocation, setMapLocation] = useState({
    address: 'Delhi',
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
     if(match.params.site_id !== undefined) {
         setSiteId(match.params.site_id);
     }
  },[match.params.site_id]);

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
      
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if(!isNaN(lati) && !isNaN(langi)){
      setMapLocation({
        address: 'Delhi6',
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
   
  }, [islatlng]);

  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  //console.log('data ' + JSON.stringify(meetingData));
  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    let isNotEmpty = true;

     // console.log(meetingDetails); return false;
    if (
      meetingDetails !== null &&
      meetingDetails?.subject !== '' &&
      meetingDetails?.body !== ''
    ) {
      //alert('aaa');
      if (meetingDetails?.subject === 'Payment Collection Meeting' || meetingDetails?.subject === 'payment collection meeting') {
        if(meetingDetails?.paymentPicked == "") {
            toast.error('Please fill payment picked');
            return false;
        }
        if (meetingDetails?.paymentPicked === 'Yes') {
            if(meetingDetails?.paymentMode == "") {
               toast.error('Please fill payment mode');
               return false;
            }
            if(meetingDetails?.saleType == "") {
              toast.error('Please select sale type');
              return false;
            }
            if(meetingDetails?.saleType === "New Sale") {
              meetingDetails?.inputIteration.map((val,index) => {
                console.log('val ' + JSON.stringify(val));
                if (!validateObject(val)) {
                  console.log('result ');
                  isNotEmpty = false;
                  toast.error('Please fill all payment details!');
                }
              });
            } else {
              meetingDetails?.inputIteration.map((val,index) => {
                if (!handleValidateObj(val)) {
                  console.log('result ');
                  isNotEmpty = false;
                  toast.error('Please fill all payment details along with attachment!');
                }
              });
            }
            
        } else if (meetingDetails?.paymentPicked === 'No') {
          if (
            meetingDetails.chequeRemark === ''
          ) {
            toast.error('Please fill reason for not picking cheque!');
            return false;
          }
        } 
        // else {
        //   toast.error('Please fill if cheque is picked!');
        //   return false;
        // }
      }
      
      setIsFiled(false);
      if(isNotEmpty !== false) {
        (async () => {
          setIsLoading(true);
          const res = await (id
            ? updateMeeting(meetingDetails)
            : createMeeting(meetingDetails));
          setIsLoading(false);
          if (res) {
            console.log(res);
            if(res.data){
              setMeetingId(res.data.id);
              setSiteId(res.data?.site_id);
            }
            setIsModal(true);
            
          }
        })();
    }
    }else{
      var errMsg = 'ERROR!';
      if(meetingDetails?.client === ''){
        errMsg = errMsg+'Client name Is Required!<br/>';  
      }
      if(meetingDetails?.subject === ''){
        errMsg = errMsg+'Subject Is Required! <br/>';  
      }
      if(meetingDetails?.body === ''){
        errMsg = errMsg+'Summary Is Required! <br/>';  
      }
      
      setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsFiled(true);
       setIsModal(false);
       return false;
    }
    // if (meetingDetails === null) {
    //   setIsFiled(true);
    //   setIsModal(false);
    //   return false;
    // } else {
    //   setIsFiled(false);
    //   (async () => {
    //     setIsLoading(true);
        // const res = await (id
        //   ? updateMeeting(meetingDetails)
        //   : createMeeting(meetingDetails));
    //     setIsLoading(false);
    //     if (res) {
    //       setIsModal(true);
    //     }
    //   })();
    // }
  };
  
  useEffect(() => {
    if (mapLocation?.lat && mapLocation?.lat !== null && getCorpClientList !== null)
      (async () => {
        setIsLoading(true);
        await getCorpClientList(match.params.site_id,mapLocation?.lat,mapLocation?.lng,match?.params?.manage_id);
        setIsLoading(false);
      })();
  }, [getCorpClientList, match?.params?.site_id,mapLocation?.lat,match?.params?.manage_id]);

  useEffect(() => {
    (async () => {
      const data = await localStorage.getItem('viewDetail');
      if (data && data !== 'undefined' && data.length) {
        const team =
          data.length && JSON.parse(data) ? JSON.parse(data)[0]?.lead_type : '';
        setTeamId(team);
      }
    })();
  }, []);

  // useEffect(() => {
  //   setSiteId(match.params.siteId);
  //   if (siteId) {
  //     (async () => {
  //       setIsLoading(true);
  //       await getPocList(siteId, match.params.id);
  //       setIsLoading(false);
  //     })();
  //   }
  // }, [siteId, getPocList, setIsLoading, match.params.id]);

  useEffect(() => {
    (async () => {
      if (id) {
        setIsLoading(true);
        let viewData = await getMeetingById(id);
        if (viewData) setViewMeeting({ ...viewData });
        setIsLoading(false);
      }
    })();
  }, [getMeetingById, id]);

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/scheduled-meeting`);
  };

  const headerBtns = () => {
    return (
      <>
      {corpClientList && corpClientList?.distanceFromSite && corpClientList?.distanceFromSite <= 500 || true ?
        <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submit}
        <img src={Images?.ArrowRight} alt="" />
        </Button>
      : <div style={{'color':'red','width': '14rem'}}>500 meter away from site.</div>}
      </>
    );
  };
  const handleModalHide1 = () => setIsErrorModal(false);
  return (
    <Layout
      title={localization.scheduleMeeting}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
      <MeetingFormSchedule
        pocList={pocList}
        handleValue={handleForm}
        siteId={match?.params?.site_id}
        meetingById={id ? meetingById : null}
        teamId={teamId}
        documentUploadUrl={documentUploadUrl}
        documentUploadUrlPublic={documentUploadUrlPublic}
        documentUrlDataPublic={documentUrlDataPublic}
        corpClientList={corpClientList}
        getCorpPocList={getCorpPocList}
        corpClientPoc={corpClientPoc}
        viewMeeting={viewMeeting}
        getInvoiceList={getInvoiceList}
        invoiceList={invoiceList}
        getBaOpportunityFromLeadx={getBaOpportunityFromLeadx}
        opportunityLis={opportunityList}
        getCorpClientList={getCorpClientList}
        manageId={(match?.params?.manage_id) ? parseInt(match?.params?.manage_id) : ''}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingTrackSuccess}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
          &nbsp;
         {meetingId && siteId ? 
          <Link
          to={`${baseUrl}/brand-activation/create-mom/${siteId}/${meetingId}`}
          className="btn btn-primary mb-4"
        >
          {localization.createMom}{' '}
          {/* <img src={Images?.ArrowRight} alt="" /> */}
        </Link>
         : null}
         
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};

SchedulePlanMeeting.propTypes = {};

export default SchedulePlanMeeting;
